// Reduced navigation — 7 grouped primary tabs replacing the previous 21-tab
// horizontal sprawl. Each entry drives the desktop dropdown in <Nav />.
// Sister sites live in NAV_NETWORK (surfaced as "SocialPulse Network ▾").
export const NAV_LINKS = [
  {
    label: "Explore",
    to: "/pulse",
    items: [
      { label: "Nature Pulse",    to: "/pulse",         description: "Live global pulse of observations" },
      { label: "Observations",    to: "/observations",  description: "Every submitted sighting" },
      { label: "Map",             to: "/civic-reports", description: "Interactive world observation map" },
      { label: "Geo Tree",        to: "/geo",           description: "Browse by geography" },
      { label: "Nature Museum",   to: "/nature-museum", description: "Featured curated collections" },
      { label: "PhotoPulse",      to: "/photopulse",    description: "Photography-first gallery" },
    ],
  },
  {
    label: "Observe",
    to: "/#identify",
    items: [
      { label: "Add Observation", to: "/#identify",     description: "Photograph, describe or paste a link" },
      { label: "Identify a Species", to: "/identify",   description: "Photograph nature — discover what you're seeing" },
      { label: "Species Pulse",   to: "/speciespulse",  description: "Discover the living world — animals, birds, insects, fungi" },
      { label: "Plant Pulse",     to: "/plants",        description: "A living global atlas of plant life" },
      { label: "Then & Now",      to: "/then-and-now",  description: "Revisit a place over time" },
      { label: "Challenges",      to: "/challenges",    description: "Weekly community projects" },
    ],
  },
  {
    label: "Weather & Climate",
    to: "/weather-pulse",
    items: [
      { label: "Weather Pulse",   to: "/weather-pulse",    description: "Report weather in seconds · live community map" },
      { label: "Happening Now",   to: "/weather-pulse/now", description: "What observers are seeing right now" },
      { label: "Weather Journal", to: "/weather-pulse/journal", description: "Your area's day-by-day record" },
      { label: "Weather Almanac", to: "/weather-almanac",  description: "Local weather + alerts" },
      { label: "Climate Hub",     to: "/climate-change",   description: "Long-term climate stories" },
      { label: "Alerts",          to: "/notifications",    description: "Local hazard & weather alerts" },
    ],
  },
  {
    label: "Stories & Learning",
    to: "/stories",
    items: [
      { label: "Science Pulse", to: "/science",  description: "Understand the world — 12 pillars, 4 levels" },
      { label: "Stories",   to: "/stories",   description: "Nature stories from the community" },
      { label: "Articles",  to: "/articles",  description: "Long-form editorial" },
      { label: "News",      to: "/news",      description: "The latest environmental news" },
      { label: "FAQ",       to: "/faq",       description: "How NaturePulse works" },
    ],
  },
  {
    label: "Community",
    to: "/experts",
    items: [
      { label: "Contributors & Experts", to: "/experts",  description: "The people behind the observations" },
      { label: "Write with us",          to: "/publisher", description: "Editor & steward console" },
    ],
  },
  {
    label: "Research",
    to: "/research",
    items: [
      { label: "Research Hub",  to: "/research", description: "Ongoing citizen-science projects" },
    ],
  },
  {
    label: "About",
    to: "/about",
    items: [
      { label: "Our Mission",        to: "/manifesto",         description: "Why NaturePulse exists" },
      { label: "About",              to: "/about",             description: "Team & story" },
      { label: "Founder's Letter",   to: "/about/founder",     description: "From Tom Vellaringattu" },
      { label: "Founder's Roadmap",  to: "/about/roadmap",     description: "What we would improve next" },
      { label: "Contact",            to: "/contact",           description: "Reach the NaturePulse team" },
      { label: "Legal",              to: "/legal",             description: "Terms, Privacy & policies" },
    ],
  },
];

// Sister-site network — surfaced under a single "SocialPulse Network ▾" chip
// on the right side of the top strip rather than in the primary nav.
export const NAV_NETWORK = [
  { label: "Farmers Pulse", to: "https://farmerspulse.com",   description: "Agriculture & farming" },
  { label: "Social Pulse",  to: "https://socialpulse.com",    description: "The parent network" },
  { label: "Food Pulse",    to: "https://foodpulse.net",      description: "Food, cuisine & culture" },
  { label: "Alumni Pulse",  to: "https://alumnipulse.net",    description: "School & alumni communities" },
];

// The five Pulse dockets — rendered as clear top-bar tabs (Nav.jsx strip).
export const PULSE_TABS = [
  { label: "Science Pulse",  to: "/science",      color: "#60A5FA", testid: "pulse-tab-science" },
  { label: "Weather Pulse",  to: "/weather-pulse", color: "#38BDF8", testid: "pulse-tab-weather" },
  { label: "Plant Pulse",    to: "/plants",        color: "#A3E635", testid: "pulse-tab-plants" },
  { label: "Species Pulse",  to: "/speciespulse",  color: "#4ADE80", testid: "pulse-tab-species" },
  { label: "Farmers Pulse",  to: "https://farmerspulse.com", color: "#FBBF24", testid: "pulse-tab-farmers", external: true },
];

// Kept for backwards compat with anything that still imports NAV_EXTERNAL.
export const NAV_EXTERNAL = NAV_NETWORK;

export const MARQUEE_TERMS = [
  "GLACIER RETREAT", "51.5074°N 0.1278°W", "APR 2025 · +1.54°C",
  "ARCTIC SEA ICE", "CO₂ · 424.6 PPM", "28.6139°N 77.2090°E",
  "MONSOON DRIFT", "AURORA A-INDEX 32", "PACIFIC SST +1.9°",
  "GREAT BARRIER · BLEACH 4", "AMAZON · −11%", "35.6762°N 139.6503°E",
  "FIRE SEASON EXTENDING", "SEA LEVEL +101 MM", "PERMAFROST −0.4M",
];

export const CATEGORIES = [
  { key: "plants",     label: "Plants",     emoji: "🌳" },
  { key: "agriculture",label: "Agriculture",emoji: "🌾" },
  { key: "insects",    label: "Insects",    emoji: "🦋" },
  { key: "birds",      label: "Birds",      emoji: "🐦" },
  { key: "wildlife",   label: "Wildlife",   emoji: "🐘" },
  { key: "aquatic",    label: "Aquatic",    emoji: "🐠" },
  { key: "fungi",      label: "Fungi",      emoji: "🍄" },
  { key: "landscapes", label: "Landscapes", emoji: "🌄" },
  { key: "water",      label: "Water",      emoji: "💧" },
  { key: "geology",    label: "Geology",    emoji: "🪨" },
  { key: "weather",    label: "Weather",    emoji: "☀️" },
];
